<template>
  <div class="wrap">
    <div class="header">
      <div style="width: 350px">
        <el-input placeholder="查询数据" v-model="merInputVal" size="medium">
          <template slot="append">搜索</template>
        </el-input>
      </div>
    </div>
    <el-card>
      <div class="content">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="工号"> </el-table-column>
          <el-table-column prop="name" label="姓名"> </el-table-column>
          <el-table-column prop="phone" label="手机"> </el-table-column>
          <el-table-column prop="pwd" label="密码"> </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="fModify(scope.row)"
                >修改</el-button
              >
              <el-button size="mini" type="danger" @click="fDel(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      merInputVal: "",
      tableData: [
        {
          id: "0001",
          name: "小北",
          phone: "18589273492",
          pwd: "23897423",
        },
        {
          id: "0002",
          name: "哈哈",
          phone: "17589231231",
          pwd: "458936",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.header {
  // height: 50px;
  display: flex;
  margin-bottom: 8px;
  margin-right: 20px;
  justify-content: space-between;
  align-items: center;
  /deep/ .el-input-group__append {
    background-color: #409eff;
    color: #fff;
    border: 1px solid #409eff;
  }
  /deep/ .buy-software .el-button--warning.is-plain {
    border-color: #ff6700;
    color: #ff6700;
  }
  /deep/ .buy-software .el-button--warning.is-plain:hover {
    background-color: #ff6700;
    color: #fff;
  }
}
.content {
  height: calc(100vh - 160px);
  overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/view/user.vue